import { ArrowBack } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function BackButton() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <IconButton
      color="primary"
      onClick={handleGoBack}
      edge="start"
      sx={{ mr: 1 }}
      size="small"
    >
      <ArrowBack fontSize="small" />
    </IconButton>
  );
}
